module.exports = "<div id=\"_trolleyMessageContainer{{messageIndex+1}}\" class=\"collectionZone-trolleyMessage u-noOutline\" ng-if=\"showMessage()\" tabindex=\"-1\" role=\"status\" aria-live=\"polite\" aria-atomic=\"true\">\r\n    <div class=\"alert alert-danger\">\r\n        {{message}}\r\n        <a href=\"javascript:;\" class=\"collectionZone-trolleyMessage-message-removeAll\" ng-click=\"::dismissMessage()\">OK<span class=\"sr-only\">, close message</span></a>\r\n    </div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/collectionzone/collection-zone-message-template.html
 ** module id = 904
 ** module chunks = 1
 **/